export default {
    data() {
        return {
            multiselect_options : {},
            multiselect_objects : {},
            multiselect_data : {},
        }
    },
    computed : {
        multiselect_selected_keys() {
            let result = {};

            _.each(this.multiselect_objects, (item, key) => {
                this.setObjects(result, key, []);
                if (!_.isNull(item))
                {
                    _.each(item, (selected, selected_item_key) => {
                        if(selected_item_key == 'key') {
                            result[key].push(selected);
                        } else if (Number.isInteger(selected_item_key)){
                            result[key].push(selected['key']);
                        }
                    })

                    if(result[key].length == 0) {
                        result[key] = [null];
                    }
                }
            });

            return result;
        }
    },
    beforeMount : function () {
        this.getSelectedOption();
    },
    methods : {
        getSelectedOption() {
            if(this.multiselect_objects && this.multiselect_options && this.multiselect_data) {
                _.each(this.multiselect_options, (val , field) => {
                    this.setObjects(this.multiselect_objects, field, {});
                    this.matchSelectedOption(field);
                    this.matchSelectedOptionByDefault(field);
                });
            }
        },
        matchSelectedOptionByDefault(field) {
            let field_key = this.multiselect_data[field];
            let objects = [];
            if(Object.keys(this.multiselect_objects[field]).length == 0) {
                if(!this.multiselect_data[field]) {
                    this.setObjects(this.multiselect_data, field, '');
                }

                // For field_key is array, loop to find matched option
                if (_.isArray(field_key)) {
                    _.each(field_key, (data_item) => {
						let object = _.find(this.multiselect_options[field], (item) => {
							return item['key'] == data_item;
						});
						if(object) {
							objects.push(object);
						}
					});
                }

                if(typeof objects == 'object' && objects.length > 0) {
                    this.setObjects(this.multiselect_objects, field, objects);
                } else {
                    // find the object used for multiselect - v-model from multiselect_data
                    let object = _.find(this.multiselect_options[field], (item) => {
                        return item['key'] == field_key;
                    });

                    // assign default option if multiselect_data[field] is set
                    if(object) {
                        this.setObjects(this.multiselect_objects, field, object);
                    } else {
                        this.setObjects(this.multiselect_objects, field, null);
                    }
                }
            }
        },
        matchSelectedOption (field) {
            // for custom matching function.
        },
        setObjects(object, key, value) {
            this.$set(object, key, value);

        },
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/multiselect.js